import React from "react"
import { renderRichText, storyblokEditable } from "gatsby-source-storyblok"
import { Href } from "../utils/helper"

const FeatureItem = ({blok}) => {

  // console.log(blok)

  return (
    <div key={blok._uid} className="flex flex-col" {...storyblokEditable(blok)}>
      <img className="w-[530px] h-[300px] object-cover rounded-md" loading="lazy" src={`${blok.image.filename}/m/0x600`} alt={blok.image.alt} />
      <div className="py-4 px-10 max-w-[480px] h-[300px] flex flex-col justify-between">
        <div className="text-xl">{blok.heading}</div>
        <img className="w-[280px] h-[7px]" src="/icons/black-dot-line.svg" alt={blok.image.alt} />
        <div className="pt-4 pb-8" dangerouslySetInnerHTML={{ __html: renderRichText(blok.description) }} />
        <a href={Href(blok.ctaUrl)} className="bg-red-600 text-white text-lg flex flex-wrap items-center w-fit px-4 py-2 rounded-lg">
          {blok.ctaText} <img className="w-[36px] h-[13px] m-2" src="/icons/newsletter-cta-arrow-right.svg" alt="Arrow right" />
        </a>
      </div>
    </div>
  )
}
  
export default FeatureItem
